import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import { renderTVShows, renderTVSchedule } from './slides'
import moment from 'moment'

Swiper.use([Navigation, Pagination, Autoplay])

export default () => {
	const initSwiper = (selector, swiper) => {
		if (document.querySelector(selector)) {
			swiper.init()
		}
	}

	const scheduleSwiper = new Swiper('.carousel--schedule .carousel__container', {
		slidesPerView: 1,
		spaceBetween: 10,
		initialSlide: 7,
		init: false,
		navigation: {
			nextEl: '.carousel--schedule .carousel__button--next',
			prevEl: '.carousel--schedule .carousel__button--prev',
		},
		breakpoints: {
			560: {
				slidesPerView: 3,
			},
			979: {
				slidesPerView: 4,
			},
		},
		on: {
			click: async (swiper) => {
				if (swiper.clickedSlide) {
					renderTVShows(swiper.clickedSlide)
				}
			},
		},
	})

	const mainPageScheduleSwiper = new Swiper('.carousel--program-list .carousel__container', {
		slidesPerView: 1,
		spaceBetween: 20,
		init: false,
		navigation: {
			nextEl: '.carousel--program-list .carousel__button--next',
			prevEl: '.carousel--program-list .carousel__button--prev',
		},
		breakpoints: {
			560: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
			},
		},
	})

	const mainPageDatesSwiper = new Swiper('.carousel--program-date .carousel__container', {
		slidesPerView: 1,
		spaceBetween: 20,
		init: false,
		navigation: {
			prevEl: '.carousel--program-date .carousel__button--prev',
			nextButton: '.carousel--program-date .carousel__button--next',
		},
		breakpoints: {
			560: {
				slidesPerView: 2,
			},
			767: {
				slidesPerView: 3,
			},
		},
		on: {
			init: async (swiper) => {
				await renderTVSchedule(swiper.slides[0], mainPageScheduleSwiper)

				const currentTime = new Date().getHours() * 60 + new Date().getMinutes()
				let slideIndex = 0
				let shouldUpdate = true

				mainPageScheduleSwiper.slides.forEach((slide, index) => {
					const dataTime = slide.getAttribute('data-time')
					const time = dataTime.match(/\d+/g)
					const slideTime = +time[0] * 60 + +time[1]

					if (currentTime > slideTime && shouldUpdate) {
						slideIndex = index
					} else {
						shouldUpdate = false
					}
				})

				mainPageScheduleSwiper.slideTo(slideIndex)
			},
			click: async (swiper) => {
				if (swiper.clickedSlide) {
					await renderTVSchedule(swiper.clickedSlide, mainPageScheduleSwiper, true)
				}
			},
		},
	})

	const promoSwiper = new Swiper('.carousel--promo .carousel__container', {
		slidesPerView: 'auto',
		init: false,
		allowTouchMove: false,
		navigation: {
			nextEl: '.carousel--promo .carousel__button--next',
			prevEl: '.carousel--promo .carousel__button--prev',
		},
		pagination: {
			el: '.carousel--promo .carousel__pagination',
			clickable: true,
		},
		observer: true,
		observeParents: true,
		on: {
			slideChange: (swiper) => {
				const prevSlide = swiper.slides[swiper.previousIndex]
				const iframe = prevSlide.querySelector('iframe')
				const video = prevSlide.querySelector('video')

				if (iframe) {
					const src = iframe.src
					iframe.src = src
				}
				if (video) {
					video.pause()
				}
			},
		},
	})

	const brandSwiper = new Swiper('.carousel--branding .carousel__container', {
		init: false,
		slidesPerView: 'auto',
		autoplay: false,
		effect: 'fade',
		loop: true,
		noSwipingClass: 'carousel__item',
		noSwiping: true,
	})

	initSwiper('.carousel--schedule .carousel__container', scheduleSwiper)
	initSwiper('.carousel--program-date .carousel__container', mainPageDatesSwiper)
	initSwiper('.carousel--branding .carousel__container', brandSwiper)
	initSwiper('.carousel--promo .carousel__container', promoSwiper)
	initSwiper('.carousel--program-list .carousel__container', mainPageScheduleSwiper)

	const program_date = document.querySelector('.carousel--program-date .carousel__container')?.swiper
	const program_list = document.querySelector('.carousel--program-list .carousel__container')?.swiper
	const schedule = document.querySelector('.carousel--schedule .carousel__container')?.swiper

	let i = 1
	const timer = setInterval(() => {
		program_date?.update()
		program_list?.update()
		schedule?.update()
		i += 1
		if (i === 20) clearInterval(timer)
	}, 100)

	if (document.querySelectorAll('.carousel--promo .carousel__container .swiper-slide').length === 1) {
		document.querySelector('.carousel--promo .swiper-wrapper').classList.add('disabled')
		document.querySelector('.carousel--promo .swiper-pagination').classList.add('disabled')
	}
	const scheduleItems = document.querySelectorAll('.js-schedule-date-slide')
	if (scheduleItems.length > 0) {
		scheduleItems.forEach((item) => {
			if (item.dataset.date === moment().subtract('5', 'hour').format('YYYY-MM-DD')) {
				item.classList.add('carousel__item--active')
			}
			item.addEventListener('click', (e) => {
				e.preventDefault()
				const activeItem = document.querySelector('.carousel__item--active')
				if (activeItem) {
					activeItem.classList.remove('carousel__item--active')
				}
				item.classList.toggle('carousel__item--active')
			})
		})
	}
}
